<template>
  <div style="min-height: 92vh">
    <ModuleHeader>Planes y beneficios</ModuleHeader>
    <v-row>
      <v-col md="8"> </v-col>
      <v-col md="4" class="text-right">
        <v-btn color="green" dark @click="exportExcel"
          ><v-icon>mdi-file-excel-box</v-icon> Exportar a Excel</v-btn
        >
        <!-- <download-excel
          type="xls"
          name="Planes Beneficios"
          :data="dataReport"
          :fields="json_fields"
        >
        </download-excel> -->
      </v-col>
    </v-row>
    <div v-if="loadingData == true">
      Cargando
    </div>
    <v-simple-table>
      <thead>
        <tr>
          <th>Plan de membresia</th>
          <template v-for="(bene, index) in beneficios">
            <th :key="index">{{ bene.nombre }}</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-if="dataReport.length == 0">
          <td colspan="7">No se encontraron datos</td>
        </tr>
        <template v-for="(res, index) in dataReport">
          <tr :key="index">
            <template v-for="(val, key) in res">
              <td
                :key="index + '-' + key"
                class="text-center"
                style="border-left: 1px solid; border-right: 1px solid"
              >
                <p v-if="val == '-' || key == 'Plan'">{{ val }}</p>
                <p v-if="(val == 'ok') & (key != 'Plan')">
                  <v-icon dark color="green"> mdi-check-circle </v-icon>
                </p>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </div>
</template>

<style>
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>

<script>
import "../../assets/css/sideBar.css";
import moment from "moment";
import { mapGetters } from "vuex";
import MembresiaPlan from "../../clases/Membresias/MembresiaPlan.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import Cliente from "../../clases/Cliente";
import Currencies from "../../clases/Currencies.js";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "ReporteMovimientos",
  components: {},
  props: ["hideMenu"],
  data() {
    return {
      data_membresias: [],
      beneficios: [],
      beneficiosProcess: [],
      loadingData: false,
    };
  },
  computed: {
    json_fields() {
      let ObjTitle = {
        Plan: "Plan",
      };
      let beneficios = this.$pgsHelper.cloneObj(this.beneficiosProcess);
      let beneficiosArray = Object.entries(beneficios);
      beneficiosArray.forEach((benef) => {
        ObjTitle[benef[1].nombre] = benef[0];
        //ObjTitle[benef[1].nombre] = benef[0]
      });
      return ObjTitle;
    },
    dataReport() {
      let data = [];
      this.data_membresias.forEach((plan) => {
        let rowObj = {
          Plan: plan.Nomb,
        };
        let beneficios = this.$pgsHelper.cloneObj(this.beneficiosProcess);
        let beneficiosArray = Object.entries(beneficios);
        beneficiosArray.forEach((benef) => {
          let exist = "-";
          benef[1].planes.forEach((plans) => {
            if (plans.plan == plan.id) {
              exist = "ok";
            }
          });
          rowObj[benef[0]] = exist;
        });
        data.push(rowObj);
      });
      return data;
    },
  },
  methods: {
    exportExcel() {
      const options = {
        json_fields: this.json_fields
      }
     GenericExcelExporter.generateExcelBuffer(this.dataReport, options)
       .then(buffer => {
         const blob = new Blob([buffer], {
           type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         });
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.download = "Planes y Beneficios.xlsx";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);
       })
       .catch(err => console.error("Error exportando Excel:", err));
   },
    async getMembresias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "MBS/Planes"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayGrupos = Object.entries(data.val());
      let grupos = [];
      arrayGrupos.forEach(function (element) {
        grupos.push({ id: element[0], ...element[1] });
      });
      this.data_membresias = grupos;
    },
    async getBeneficiosEnPlan() {
      await this.$store.getters.getFirebaseApp.fba
        .call("MBS-Beneficios-beneficiosEnPlanes", {})
        .then((result) => {
          this.beneficios = result.data.data;
          this.beneficiosProcess = result.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeCreate: function () {},
  beforeMount: async function () {
    await this.getMembresias();
    await this.getBeneficiosEnPlan();
  },
};
</script>
